import { render } from "./Adjustment.vue?vue&type=template&id=39da51ab&ts=true"
import script from "./Adjustment.vue?vue&type=script&lang=ts"
export * from "./Adjustment.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__